import HttpClient from '../../core/services/http-client';
import { API_BASE_URL, BASE_BUY_TICKETS_PATH, BASE_CART_TICKETS_PATH, BASE_DELETE_CART_PATH, BASE_RESTORE_CART_PATH,
    BASE_SAVE_CONTACT_DETAILS_PATH } from './config';

export const fetchCartTickets = () => HttpClient.execute(`${API_BASE_URL}${BASE_CART_TICKETS_PATH}`, 'GET');
export const doDeleteCartTickets = () => HttpClient.execute(`${API_BASE_URL}${BASE_DELETE_CART_PATH}`, 'POST');
export const doSaveContactDetails = (payload) => HttpClient.execute(`${API_BASE_URL}${BASE_SAVE_CONTACT_DETAILS_PATH}`, 'POST', {}, payload);
export const doBuyTickets = () => HttpClient.execute(`${API_BASE_URL}${BASE_BUY_TICKETS_PATH}`, 'POST');
export const doRestoreCart = () => HttpClient.execute(`${API_BASE_URL}${BASE_RESTORE_CART_PATH}`, 'POST');
